const JockeyFilterComparator = {
    displayName: (row, filterValues) => row.displayName.toLowerCase().includes(filterValues.name),
    personality: (row, filterValues) => row.personality === filterValues.personality,
    status: (row, filterValues) => {
        return true;
    } //TODO wip proper implementation
};
export default JockeyFilterComparator;
